import React from "react";
import cn from "classnames";
import type { LabelProps } from "./types";
import styles from "./DiscountLabel.module.scss";

/** Компонент лейбл для отображения скидки  */
const DiscountLabel: React.FC<LabelProps> = ({
  type = "percent",
  size = "",
  ...props
}) => {
  const { hasBorder, text, labelClass, containerClass } = props;
  const stylesStrings = styles as unknown as Record<string, string>;
  // минус вместо дефиса
  const labelText = text.replace("-", "−");
  return (
    <div
      className={cn(styles.container, containerClass)}
      data-testid="artDiscount--wrapper"
    >
      <div
        className={cn(
          stylesStrings[`label_${type}`],
          {
            [stylesStrings[`label_${type}_border`]]: hasBorder,
          },
          hasBorder
            ? stylesStrings[`label_${size}_border`]
            : stylesStrings[`label_${size}`]
        )}
      >
        <div
          className={cn(
            styles.textLabel,
            stylesStrings[`textLabel_${type}`],
            {
              [stylesStrings[`textLabel_${type}_border`]]: hasBorder,
              [stylesStrings[`textLabel_${size}`]]: !!size,
              [stylesStrings[`textLabel_${size}_border`]]: hasBorder && !!size,
            },
            labelClass
          )}
        >
          {labelText}
        </div>
      </div>
    </div>
  );
};

export default DiscountLabel;
